import React, { Component } from 'react';
import TableParent from '../commonComponents/TableParent';
import CallAPI from '../commonComponents/AxiosHelper';
import LoadingComponent from '../commonComponents/LoadingComponent';
import ErrorComponent from '../commonComponents/ErrorComponent';
import Form from '../commonComponents/Form.v2';
import DatasetFilter from '../commonComponents/DatasetFilter';
import sanitizeHtml from 'sanitize-html';


class MetricformatComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            columns: null,
            accessError:null,
            metricPrefix: {
                "None": { "name": "None", "value": null },
                "true": { "name": "Prefix", "value": "true" },
                "false": { "name": "Suffix", "value": "false" }
            },
            metricUnit: {
                "None": { "name": "None", "value": null },
                "INR": { "name": "INR", "value": "INR" },
                "%": { "name": "%", "value": "%" },
                "$": { "name": "$", "value": "$" },
                "Mn": { "name": "Mn", "value": "Mn" }
            },
            numberShorten: {
                "in": { "name": "General", "value": "in" },
                "k": { "name": "Thousands", "value": "k" },
                "l": { "name": "Lakhs", "value": "l" },
                "m": { "name": "Millions", "value": "m" },
                "cr": { "name": "Crores", "value": "cr" }
            },
            roundOff: {
                "0": { "name": "0", "value": "0" }, "1": { "name": "1", "value": "1" }, "2": { "name": "2", "value": "2" }, "3": { "name": "3", "value": "3" }, "4": { "name": "4", "value": "4" }, "5": { "name": "5", "value": "5" }, "6": { "name": "6", "value": "6" }, "7": { "name": "7", "value": "7" }, "8": { "name": "8", "value": "8" }, "9": { "name": "9", "value": "9" }, "10": { "name": "10", "value": "10" }
            }

        };

        this.headerData = {
            "name": { "name": "name", "label": "Name", "type": "text" },
            "metricUnit": { "name": "metricUnit", "label": "Metric Unit", "type": "dropdown" },
            "metricDisplay": { "name": "metricPrefix", "label": "Metric Display", "type": "dropdown" },
            "numberShorten": { "name": "numberShorten", "label": "Number Shorten", "type": "dropdown" },
            "numberRoundoff": { "name": "roundOff", "label": "Number Roundoff", "type": "number" },
        }

        this.bulkFormData = {
            "metricPrefix": {
                "name": "metricPrefix", "label": "Metric Prefix", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "" }, ...Object.values(this.state.metricPrefix)
                ], "requiredFlag": true
            },
            "metricUnit": {
                "name": "metricUnit", "label": "Metric Unit", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "" }, ...Object.values(this.state.metricUnit)
                ], "requiredFlag": true
            },
            "numberShorten": {
                "name": "numberShorten", "label": "Shorten", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "" }, ...Object.values(this.state.numberShorten)
                ], "requiredFlag": true
            },
            "roundOff": {
                "name": "roundOff", "label": "Round Off", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "" }, ...Object.values(this.state.roundOff)
                ], "requiredFlag": true
            },
        }

        this.importFormData = {
            "fileImport": {
                "name": "fileImport", "label": "File Import", "type": "file"
            }
        }

        this.headerMapping = {
            "name": "Name",
            "isDerived": "Metric Type",
            "formula": "Formulae",
            "defaultFormula": "Aggregation Type",
            "isDisplay": "Display"
        }

        this.buttons = {
            "addButton": [{ "label": "Add", "type": "normal", "display": false, "action": "add" }],
            "dropdownConfig": [{
                "label": "More", "type": "dropdown", "display": true,
                "children": [
                    // {  "label": "File Format Download", "action": "file" },
                    { "label": "Export CSV", "action": "export" },
                    // { "label": "Import CSV", "action": "import" },
                ]
            }],
            "editButton": [{ "class": "", "label": "Edit", "type": "normal", "display": true, "action": "edit" }],
            "saveButton": [{
                "class": "", "label": "Save", "type": "normal", "display": false, "action": "save"
            }],
            "cancelButton": [{ "class": "", "label": "Cancel", "type": "normal", "display": false, "action": "cancel" }],
            "loadingButton": [{ "id": "loadingButton", "type": "loading", "display": false, "action": "load" }]
        }
        this.change_handle = this.change_handle.bind(this);
        this.saveHandle = this.saveHandle.bind(this);
        this.change_table_format = this.change_table_format.bind(this);
        this.handleDataUpdate = this.handleDataUpdate.bind(this);
        this.text_to_json = this.text_to_json.bind(this);
        this.fetchMetricFormatData = this.fetchMetricFormatData.bind(this);
        this.formatColumnStatus = this.formatColumnStatus.bind(this);

    }

    componentWillMount() {
        this.fetchMetricFormatData();
    }


    componentDidMount() {
        jQuery(".custom-file-input").on("change", function () {
            var fileName = jQuery(this).val().split("\\").pop();
            jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        });
    }


    componentDidUpdate(prevProps, nextState) {
        if (prevProps.datasetValue !== this.props.datasetValue) {
            let that = this;
            this.fetchMetricFormatData();
        }
        jQuery('[data-toggle="popover"]').popover();

    }

    fetchMetricFormatData() {
        let that = this;
        that.setState({ columns: null });
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: this.props.datasetValue
        }
        CallAPI('get', '/app/getheaderdataforrefine', null, params, 0, function (response) {
            if (response?.status==false) {
                checkIfMaintenanceModeOn(response)
            } else if (response?.status == 500) {
                that.setState({ accessError: true });
            }
            that.setState({ columns: response })
        },this.props.authData)
    }

    change_handle(data) {
        let allColumns = this.state.columns
        let metric_obj = this.state.columns.metric;
        let final_value = data.value;
        let field = data.colDef.field == "label" ? "value" : data.colDef.field;
        let checkValidity = true
        if (field == 'name') {
            checkValidity = checkSpecialChars(final_value, 'metricLabel') ? false : true
        }
        if (checkValidity == false) {
            alert('Please enter valid inputs for metric label!\n(Only alphabets, numbers, hyphen(-), underscore(_), percent(%) are allowed.)')
            this.setState({ columns: allColumns })
        } else {
            if (this.state[data.colDef.field]) {
                Object.values(this.state[data.colDef.field]).map(function (innerData) {
                    if (innerData.name == data.value) {
                        final_value = innerData.value;
                    }
                })
            }
            if (final_value !== metric_obj[data.node.id][field]) {
                metric_obj[data.node.id][field] = final_value;
                metric_obj[data.node.id]['rockmetric_update'] = true;
                if (metric_obj[data.node.id]['rockmetric_update_columns'] == undefined) {
                    metric_obj[data.node.id]['rockmetric_update_columns'] = []
                }
                metric_obj[data.node.id]['rockmetric_update_columns'].push(data.colDef.field);
                metric_obj[data.node.id]['rockmetric_update_columns'] = [...new Set(metric_obj[data.node.id]['rockmetric_update_columns'])];
            }
        }
    }

    saveHandle() {
        let that = this,
            checkValidity = true,
            params = {
                siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
                toolId: this.props.datasetValue
            }
        that.state.columns.metric.map(function (innerData) {
            checkValidity = checkValidity ? (checkSpecialChars(innerData.name, 'metricLabel') ? false : true) : false
        })
        if (checkValidity === false) {
            alert('Please enter valid input!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
        } else if (confirm("Please Confirm to Update!")) {
            isAdHocDataLoading();
            let filteredArray = this.state.columns.metric.filter((element, i) => {
                return element.rockmetric_update == true;
            });
            CallAPI('POST', '/app/metricdefination', filteredArray, params, 0, function (response) {
                alert("Successfully Submitted");
                // window.location.reload();
                that.fetchMetricFormatData();
            }, this.props.authData)
        }
    }

    text_to_json(data) {
        let that = this;
        csv({
            output: "json",
            noheader: false,
            headers: Object.keys(this.headerMapping),
            // nullObject:true,
            colParser: {
                "metricPrefix": function (item, head, resultRow, row, colIdx) {
                    let metricType = that.getJSON(Object.values(that.state[head]));
                    return metricType[item] ? metricType[item] : null;
                },
                "metricUnit": function (item, head, resultRow, row, colIdx) {
                    let unit = that.getJSON(Object.values(that.state[head]));
                    return unit[item] ? unit[item] : null;
                },
                "numberShorten": function (item, head, resultRow, row, colIdx) {
                    let shorten = that.getJSON(Object.values(that.state[head]));
                    return shorten[item] ? shorten[item] : null;
                },
                "roundOff": function (item, head, resultRow, row, colIdx) {
                    let roundOff = that.getJSON(Object.values(that.state[head]));
                    return roundOff[item] ? roundOff[item] : null;
                }
            }
        }).fromString(data)
            .then(function (result) {
                let metric = that.state.metric;

                metric.metric = [...result, ...metric.metric];
                that.setState({
                    metric: metric
                });
                jQuery("#importKPI").modal('hide');
                that.handleButton(null, 1);
            })
    }

    change_table_format(array_data) {

        try{
            var that = this;
            let temp_array = [];
            array_data.map(function (innerData, index) {
                let inner_temp_array = [];

                inner_temp_array.label = innerData.value;

                inner_temp_array.name = innerData.name;

                inner_temp_array.metricPrefix = innerData.metricPrefix ? that.state.metricPrefix[innerData.metricPrefix].name : that.state.metricPrefix["None"].name;

                // inner_temp_array.metricUnit = innerData.metricUnit;
                inner_temp_array.metricUnit = innerData.metricUnit ? that.state.metricUnit[innerData.metricUnit].name : that.state.metricUnit["None"].name

                inner_temp_array.numberShorten = innerData.numberShorten ? that.state.numberShorten[innerData.numberShorten].name : that.state.numberShorten["in"].name;

                inner_temp_array.roundOff = innerData.roundOff ? that.state.roundOff[innerData.roundOff].name : that.state.roundOff["0"].name;

                temp_array.push(inner_temp_array);

            })

            return { data: temp_array };
        }
        catch(e){
            return "error";
        }
    }

    handleDataUpdate(data) {
        let columns = this.state.columns;
        columns.metric = data;
        this.setState({
            columns: columns
        })
    }

    formatColumnStatus(params) {
        let htmlString = `<span>${params.value}</span>`;
        const index = params.node.id;
        let icon = '';
        const statusObj = this.state.columns.metric[index]['status'];
        if (statusObj !== null && statusObj !== undefined) {
            const status = JSON.parse(statusObj);
            if (status !== null && status !== undefined) {
                const id = `${params.value}_${index}`;
                if (status.status) {
                    // icon = '<i class="fas fa-check-circle mg-t-2 float-right mg-t-5" style="color:#04cc82"></i>';
                    icon = '<i id="' + id + '" class="fas fa-check-circle mg-t-2 float-right mg-t-5" style="color:#04cc82"></i>';
                }
                else {
                    let error_message = status.error_message;
                    let link = "<a href='/admin/metric' class='mg-l-5'>Fix Column</a>";
                    const error_html = "<span>" + error_message + link + "</span>";

                    // icon = '<i id="' + id +'" class="fas fa-exclamation-circle float-right mg-t-5" data-container="body" data-toggle="tooltip" data-placement="bottom" title="'+error_message+'" style="color:#ff726f"></i>';

                    icon = '<i id="' + id + '" class="fas fa-exclamation-circle float-right mg-t-5" data-container="body" data-toggle="popover" data-html="true" data-placement="bottom"  data-content="' + error_html + '" style="color:#ff726f"></i>';
                    // icon = `<i class="fas fa-exclamation-circle mg-t-2 float-right" data-container="body" data-toggle="popover" data-placement="bottom" data-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." style="color:#ff726f"></i>`;
                }

                htmlString = `<span>${params.value}${icon}</span>`;
            }
        }

        return htmlString;
    }

    render() {

        // console.log(this.props);
        var mainData = <LoadingComponent/>;
        if (this.state.columns) {
            let final_data = this.change_table_format(this.state.columns.metric);

            if(final_data !== "error"){
                let metricPrefix = Object.values(this.state.metricPrefix).map(function (value) {
                    return value.name;
                });

                let metricUnit = Object.values(this.state.metricUnit).map(function (value) {
                    return value.name;
                });

                let numberShorten = Object.values(this.state.numberShorten).map(function (value) {
                    return value.name;
                });

                let roundOff = Object.values(this.state.roundOff).map(function (value) {
                    return value.name;
                });
                var columns_array = [
                    { label: "Label", value: "name", type: "html", type: "html", editable: true, hide: false, dataType: 'string'},
                    { label: "Unit", value: "metricUnit", type: "html", dropdown_value: metricUnit, editable: true, hide: false, dataType: 'string'},
                    { label: "Unit Position", value: "metricPrefix", type: "html", dropdown_value: metricPrefix, editable: true, hide: false, dataType: 'string' },
                    { label: "Shorten", value: "numberShorten", type: "html", hide: false, dropdown_value: numberShorten, editable: true, dataType: 'string' },
                    { label: "Decimal Round Off", value: "roundOff", type: "html", hide: false, dropdown_value: roundOff, editable: true, dataType: 'number' }
                ];

                var firstColumn = "Column Name";
                // var Form_Data = <Form label_array={this.formData} call_back={this.call_back_form} />;
                var Bulk_Form_Data = <Form label_array={this.bulkFormData} call_back={this.call_back_form} />;
                var import_Form_Data = <Form label_array={this.importFormData} call_back={this.call_back_form} />;

                var modals = {
                    "addModal": {
                        "form_name": "add_form", "title": "Add Metric", "body": null, "button_name": "Add", "action": "add", "display": false, buttonType:"submit"
                    },
                    "bulkModal": {
                        "form_name": "bulk_form", "title": "Edit Metric Format", "body": Bulk_Form_Data, "button_name": "Update", "action": "bulk", "display": true, buttonType:"submit"
                    },
                    "importModal": {
                        "form_name": "import_form", "title": "Import Metric Format", "body": import_Form_Data, "button_name": "Import", "action": "import", "display": true, buttonType:"submit"
                    }
                }

                var mainData = <TableParent
                    data={final_data}
                    parentConfig={this.state}
                    columns_array={columns_array}
                    firstColumn={firstColumn}
                    editData={this.state.columns.metric}
                    modalConfig={modals}
                    onCellChange={this.change_handle}
                    filename="Metric Formats List"

                    // actionArray={this.props.menuData}
                    menuAction={this.handleMenuAction}
                    handleDataUpdate={this.handleDataUpdate}
                    submitHandle={this.saveHandle}
                    buttonConfig={this.buttons}
                    rowSelection="multiple"
                    firstCellRender={this.formatColumnStatus}
                />
            }
            else {
                mainData = this.state.accessError ? <div className="d-flex">
                    <div class="alert alert-danger h-25 mg-b-0 mg-t-5" role="alert"><i data-feather="alert-circle" class="mg-r-10"></i>
                        This dataset don’t have admin access. Kindly provide admin access. <a href="/admin/useraccess" class="alert-link" target="_blank">Click here for grant permission</a>
                    </div>
                </div> : <ErrorComponent />;
            }
        }
      

        return (
            <div>
                <div className="wd-300">
                    <DatasetFilter />
                </div>
                {mainData}
            </div>
        );
    }
}

export default MetricformatComponent;